<template>
    <div>
        <img src="https://storage.googleapis.com/bluegiraffelabs_web/bgl-header.png">
        <div>
            <section class="section has-text-white">
                <h1 class="title is-3 has-text-white">Pricing</h1>
                <div class="container">
                    <table class="table">
                        <thead>
                            <tr>
                            <th></th>
                            
                            <th><abbr title="Played"></abbr></th>
                            <th><abbr title="Won">W</abbr></th>
                            <th><abbr title="Drawn">D</abbr></th>
                            <th><abbr title="Lost">L</abbr></th>
                            <th><abbr title="Goals for">GF</abbr></th>
                            <th><abbr title="Goals against">GA</abbr></th>
                            <th><abbr title="Goal difference">GD</abbr></th>
                            </tr>
                        </thead>
                        
                        <tbody>
                            <tr>
                            <td><img src="https://storage.googleapis.com/bluegiraffelabs_web/trifectayum_app_icon.png" width="150"></td>
                            <td>23</td>
                            <td>12</td>
                            <td>3</td>
                            <td>68</td>
                            <td>36</td>
                            <td>+32</td>
                            <td>81</td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="table">
                        <thead>
                            <tr>
                            <th></th>
                            
                            <th><abbr title="Played"></abbr></th>
                            <th><abbr title="Won">Basic Plan</abbr></th>
                            <th><abbr title="Drawn">Premium Plan</abbr></th>
                            
                            </tr>
                        </thead>
                        
                        <tbody>
                            <tr>
                            <td><img src="https://storage.googleapis.com/bluegiraffelabs_web/trifectayum_app_icon.png" width="150"></td>
                            <td>23</td>
                            <td>12</td>
  
                            </tr>
                        </tbody>
                    </table>
                </div>
                

            </section>
        </div>
    </div>
</template>

<script>
export default {
  name: 'pricing'
}
</script>

<style>
ul.a {
  list-style-type: circle;
left: 10px;
}

</style>
